<template>
  <div>
    <div class="attachmentTabContainer">
      <div v-if="data['mode'] != 'V'" class="newAttachmentContainer">
        <div class="newAttachmentMethodContainer addAttachment">
          <Input textType="file" placeholder="Browse" @fileChanged="fileChanged($event)" ref="addAttachmentInput"/>
          <Input placeholder="Remarks" :inputValue.sync="addAttachmentRemarks" />
          <button @click="addAttachment">Add Attachment</button>
        </div>
        <div class="newAttachmentMethodContainer selectJobDocument">
          <button @click="showJobDocuments()">Select Documents from Job</button>
        </div>
      </div>
      
      <TableBox title="Attachments" :tableData="attachmentsTableData" :selectedRow.sync="selectedAttachments" :maxSelection="-1" :hideColumns="[ 'DocumentGUID', 'File Type', 'File Data' ]" :dataType="{ 'Date Added':'date' }" />
      <button v-if="data['mode'] != 'V'" style="margin-top: 3px;" @click="removeAttachments()">Remove Attachments</button>
    </div>
    
    <div v-if="showJobDocumentsPopup" class="jobDocumentsPopupContainer">
      <div class="jobDocumentsPopup">
        <div :style="{width: showPreview ? '50%' : '100%' }">
          <div class="jobDocumentsRefreshBar">
            <span style="margin-right: 3px;">Last Refreshed: {{jobDocumentsLastRefresh}}</span>
            <button @click="refreshJobDocuments()">Refresh</button>
          </div>
          <div class="jobDocumentTableBoxContainer">
            <TableBox title="Job Documents" :tableData="jobDocumentsTableData" :loading="loadingJobDocuments" groupBy="ID" :hideColumns="[ 'documentGUID', 'ID', 'fileAtt', 'filetype' ]" :maxSelection="-1" :selectedRow.sync="selectedJobDocuments" />
          </div>
          <div class="jobDocumentActionButtonContainer">
            <button class="jobDocumentActionButton" @click="attachJobDocumentToROT">Attach to ROT</button>
            <button class="jobDocumentActionButton" @click="showJobDocumentsPopup = false">Cancel</button>
          </div>
        </div>
        
        <!-- <iframe v-if="showPreview" class="filePreview" :src="previewFileData"></iframe> -->
        <div v-if="showPreview" class="filePreviewContainer">
          <object v-if="!isImage" class="filePreview" :type="previewFileType" :data="previewFileData"></object>
          <img v-if="isImage" :src="previewFileData"> <!-- need both <object> and <img>, because object automatically scales the image to fit -->
        </div>                                        <!-- the size of the div, which may make it look distorted -->
        

      </div>
    </div>

    <PopupV2 :show="showPopup" type="error" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false" />
    
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      attachmentsTableData: [],
      selectedAttachments: [],
      
      addAttachmentFile: null,
      addAttachmentRemarks: '',
      addAttachmentGUIDCounter: 1, // assign temporary GUIDs to newly uploaded files from the user

      showJobDocumentsPopup: false,
      initialLoad: true, // load job documents once on first jobdocumentspopup show, will not reload again in the future, unless refresh is pressed
      jobDocumentsLastRefresh: '',
      loadingJobDocuments: false,
      jobDocumentsTableData: [],
      selectedJobDocuments: [],

      showPreview: false,
      isImage: false,
      previewFileType: '',
      previewFileData: '',

      showPopup: false,
      popupTitle: '',
      popupContent: '',
    }
  },
  computed: {
    mergedAttachmentsTableData: function() {
      return this.data['ROTAttachments'].concat(this.data['NewROTAttachments']);
    }
  },
  props: {
    data: { type: Object, default: function () { return {} } },
  },
  methods: {
    refreshJobDocuments: async function() {
      this.jobDocumentsLastRefresh = this.$dateTime.getDateTime(null, 'yyyy-MM-dd HH:mm');
      this.loadingJobDocuments = true;

      let jobDocuments = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${this.data['JobNo']}`);
      this.jobDocumentsTableData = [];
      jobDocuments.forEach((d) => {
        if (d['AttImage'] && d['AttImageType'] && d['Doc Code'].trim() != 'ECMR' && d['Doc Code'] != 'eROT') {
          this.jobDocumentsTableData.push({
            'Doc Code': d['Doc Code'],
            'Doc Ref #': d['Reference No'],
            'Attachment': d['AttImageName'],
            'Remarks': d['Remarks'],
            'Status': d['Status Count'] > 0 ? d['Status Code'] : 'N/A',
            'Start Date': d['Status Count'] > 0 ? d['Start DateTime'] : 'N/A',
            'Received Date': d['Status Count'] > 0 ? d['Received DateTime'] : 'N/A',
            'Due Date': d['Status Count'] > 0 ? d['Due DateTime'] : 'N/A',
            'Assign To': d['Status Count'] > 0 ? d['Assign To'] : 'N/A',
            'Sets': d['Status Count'] > 0 ? d['Sets'] : 'N/A',
            'Page': d['Status Count'] > 0 ? d['Pages'] : 'N/A',

            'documentGUID': d['DocumentGUID'],
            'ID': `${d['Doc Code']}-${d['Reference No']}`,
            'fileAtt': d['AttImage'],
            'filetype': d['AttImageType'],
          });
        }
      });
      this.loadingJobDocuments = false;
    },
    fileChanged: async function(file) {
      this.addAttachmentFile = file; // assign FileList to addAttachmentFile
    },
    showJobDocuments: async function() {
      this.selectedJobDocuments = [];
      
      if (this.initialLoad) {
        this.refreshJobDocuments(); // async method
        this.initialLoad = false;
      }

      this.showJobDocumentsPopup = true; // show popup while job documents are still loading
    },
    addAttachment: async function() {
      if (!this.addAttachmentFile || this.addAttachmentFile.length == 0) { // if addAttachmentFile is null or has a length of 0
        this.popupTitle = "No File Selected";
        this.popupContent = "Browse for a file to add as an attachment";
        this.showPopup = true;
        return;
      }

      let addedAttachment = {
        "File Name": `${this.addAttachmentFile[0]['name'].trim()} *`,
        "Date Added": this.$dateTime.getDateTime(null, "yyyy-MM-dd"),
        "Remarks": this.addAttachmentRemarks,
        "File Type": this.addAttachmentFile[0]['type'],
        "File Data": await this.$convertFile.toBase64(this.addAttachmentFile[0]),
        "DocumentGUID": `TEMPORARY-GUID-${this.addAttachmentGUIDCounter++}`, // post increment
      }

      this.attachmentsTableData = []; // clear attachments TableBox data
      this.data['NewROTAttachments'] = this.data['NewROTAttachments'].concat(addedAttachment);

      this.$nextTick(() => {
        this.attachmentsTableData = this.mergedAttachmentsTableData;
      });

      this.$refs['addAttachmentInput'].clearAttachmentClicked(); // clear file input
      this.addAttachmentRemarks = ""; // clear remarks input
      
    },
    attachJobDocumentToROT: function() {
      if (this.selectedJobDocuments.length == 0) {
        this.popupTitle = "No Job Documents Selected";
        this.popupContent = "Select a job document to add";
        this.showPopup = true;
        return;
      }
      
      let selected = [];
      for (let jobDocument of this.selectedJobDocuments) {
        if (
          this.data['ROTAttachments'].filter((attachment) => { return attachment['DocumentGUID'] == jobDocument['documentGUID']}) == 0 && // not already attached to ROT
          this.data['NewROTAttachments'].filter((attachment) => { return attachment['DocumentGUID'] == jobDocument['documentGUID']}) == 0 // not already selected to be attached to ROT
        )
        {
          selected.push({
            "File Name":jobDocument["Attachment"] ? `${jobDocument["Attachment"].trim()} *` : 'NoFileName',
            "Date Added":this.$dateTime.getDateTime(null, "yyyy-MM-dd"),
            "Remarks":jobDocument["Remarks"],
            "File Type":jobDocument["filetype"],
            "File Data":jobDocument["fileAtt"],
            "DocumentGUID":jobDocument["documentGUID"],
          });
        }
      }

      if (selected.length == 0) {
        this.popupTitle = "No Unattached Selections";
        this.popupContent = "Selected job documents have already been attached to the ROT";
        this.showPopup = true;
        return;
      }

      this.attachmentsTableData = []; // clear attachments TableBox data
      this.data['NewROTAttachments'] = this.data['NewROTAttachments'].concat(selected);
      
      this.$nextTick(() => {
        this.attachmentsTableData = this.mergedAttachmentsTableData;
      });
      this.showJobDocumentsPopup = false;
    },
    removeAttachments: function() {
      if (this.selectedAttachments.length == 0) {
        this.popupTitle = "No Attachment Selected";
        this.popupContent = "Select an attachment to remove";
        this.showPopup = true;
      } else {
        let selectedAttachments = this.selectedAttachments; // store in temp variable
        this.attachmentsTableData = [];                     // so that I can clear the attachments TableBox
        this.selectedAttachments = [];                      // and the selected attachments to be removed

        for (let selectedAttachment of selectedAttachments) {
          if (selectedAttachment['File Data'] || selectedAttachment['File Type']) { // if it is a new attachment
            
            this.data['NewROTAttachments'] = this.data['NewROTAttachments'].filter((attachment) => { return attachment['DocumentGUID'] != selectedAttachment['DocumentGUID'] });
            // filter out the attachment with the same GUID as the selected attachment
          
          } else { // if it is an existing attachment
            let indexToRemove = this.data['ROTAttachments'].findIndex((attachment) => { return attachment['DocumentGUID'] == selectedAttachment['DocumentGUID'] });
            // find index of attachment with the same GUID

            this.data['RemovedROTAttachments'].push((this.data['ROTAttachments'].splice(indexToRemove, 1))[0]);
            // remove from ROTAttachments and push the removed attachment to RemovedROTAttachments
            // splice returns the removed attachments in an array
            // access the first element (there will only ever be 1) and just push the JS object to RemovedROTAttachments instead of the whole array
          }
        }

        this.$nextTick(() => {
          this.attachmentsTableData = this.mergedAttachmentsTableData;
        });
      }
    },
  },
  mounted() {
    this.attachmentsTableData = this.mergedAttachmentsTableData;
  },
  watch: {
    selectedJobDocuments: function(selected) {
      if (selected.length == 0) {
        this.showPreview = false;
        return;
      }

      let lastSelected = selected[selected.length - 1];
      if (!lastSelected['fileAtt'] || !lastSelected['filetype'])        
        return;        
      

      this.previewFileType = lastSelected['filetype'];
      this.previewFileData = `data:${lastSelected['filetype']};base64,${lastSelected['fileAtt']}`;

      if (this.previewFileType.startsWith('image/'))
        this.isImage = true; // if it is an image, preview using <img>
      else
        this.isImage = false; // if it isn't, preview using <object>

      this.showPreview = true;
      return;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.attachmentTabContainer {

}

.newAttachmentContainer {
  display: flex;
  flex-direction: row;
}

.newAttachmentMethodContainer {
  display: flex;
  flex: 1;
  margin: 5px;
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;  
}

.addAttachment {
  flex-direction: column;
}

.selectJobDocument {
  align-items: center;
  justify-content: center;
}

.jobDocumentsPopupContainer {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jobDocumentsPopup {
  height: 90%;
  width: 90%;
  margin-top: 50px;
  padding: 10px;
  background-color: white;  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // border: 1px solid red;
}

.jobDocumentsRefreshBar {
  text-align: right;
  margin-bottom: 3px;
}

.jobDocumentTableBoxContainer {
  height: 90%;
  // border: 1px solid red; 
}

.jobDocumentActionButtonContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 3px 0;
  // border: 1px solid red;
}

.jobDocumentActionButton {
  margin: 0 3px;
}

.filePreviewContainer {
  width: 50%;
}

.filePreview {
  height: 100%;
  width: 100%;
}

</style>